























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
@Component({
  name: 'form-title'
})
export default class extends Vue {
  @Prop({ required: true }) private value!: number
  @Prop({ required: true }) private max!: number

  private radio: number = this.value > this.max ? this.max : this.value

  handleInput(i: number) {
    this.$emit('input', i)
    this.$emit('change', i)
  }

  handleClick(i: number) {
    if (this.radio === i) {
      this.radio = 0
      this.$emit('input', 0)
      this.$emit('change', 0)
    }
  }

  @Watch('value')
  private onChange(newVal: number) {
    this.radio = newVal > this.max ? this.max : newVal
  }
}
